import { isBrowser } from '../../../utils/utils';
import { MSG_NAME_FROM_IFRAME } from '../type';
import { onApplyForcedVariations, onQaAssistantClose, onQaAssistantReady, onResetForcedVariations, render, onVariationsForcedAllocation, onVariationsForcedUnallocation, onRemoveForcedVariation } from './iframeMessageActions';
export function handleIframeMessage({ event, config, func, visitorVariationState }) {
    if (!config.isQAModeEnabled || !isBrowser()) {
        return;
    }
    switch (event.data.name) {
        case MSG_NAME_FROM_IFRAME.FsQaAssistantReady:
            onQaAssistantReady(visitorVariationState);
            break;
        case MSG_NAME_FROM_IFRAME.MinimizeQaAssistantClose:
        case MSG_NAME_FROM_IFRAME.QaAssistantClose:
            onQaAssistantClose({
                config,
                func,
                visitorVariationState
            });
            break;
        case MSG_NAME_FROM_IFRAME.FsApplyForcedVariations:
            onApplyForcedVariations({
                value: event.data.value,
                visitorVariationState
            });
            break;
        case MSG_NAME_FROM_IFRAME.FsResetForcedVariations:
            onResetForcedVariations(visitorVariationState);
            break;
        case MSG_NAME_FROM_IFRAME.FsTriggerRender:
            render(true);
            break;
        case MSG_NAME_FROM_IFRAME.FsVariationsForcedAllocation:
            onVariationsForcedAllocation({
                value: event.data.value,
                visitorVariationState
            });
            break;
        case MSG_NAME_FROM_IFRAME.FsVariationsForcedUnallocation:
            onVariationsForcedUnallocation({
                value: event.data.value,
                visitorVariationState
            });
            break;
        case MSG_NAME_FROM_IFRAME.FsRemoveForcedVariation:
            onRemoveForcedVariation({
                keys: event.data.value,
                visitorVariationState
            });
            break;
    }
}
